import request from "../index"


// 接口基础路径
const rootApi = '/api_v2'

//检验模块文件列表
export const getMaterielDocumentList = (materielId) => {
	return request.get(`${rootApi}/materiel/${materielId}/documentList`)
}